import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import { getUserMenus, getUserInfo } from '@/api/auth'
import { getSiteConfig } from '@/api/config'

// 动态设置页签图标：Canvas 裁切为正方形
function setFavicon(url) {
  if (!url) return
  const img = new Image()
  img.crossOrigin = 'anonymous'
  img.onload = () => {
    const size = 64
    const canvas = document.createElement('canvas')
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext('2d')
    // 居中裁切为正方形
    const min = Math.min(img.width, img.height)
    const sx = (img.width - min) / 2
    const sy = (img.height - min) / 2
    ctx.drawImage(img, sx, sy, min, min, 0, 0, size, size)
    // 设置 favicon
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = canvas.toDataURL('image/png')
  }
  img.src = url
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sidebarCollapsed: false,
    siteConfig: { siteName: '', siteLogo: '' }
  },
  mutations: {
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    SET_SITE_CONFIG(state, config) {
      state.siteConfig = config
    }
  },
  actions: {
    async fetchSiteConfig({ commit, state }) {
      try {
        const lang = state.user.lang || 'ru'
        const res = await getSiteConfig(lang)
        const config = res.data || {}
        commit('SET_SITE_CONFIG', config)
        setFavicon(config.siteLogo)
        return config
      } catch (e) {
        return {}
      }
    }
  },
  modules: {
    user: {
      namespaced: true,
      state: {
        token: Cookies.get('token') || '',
        userInfo: null,
        lang: localStorage.getItem('admin_lang') || 'ru',
        menus: []
      },
      mutations: {
        SET_TOKEN(state, token) {
          state.token = token
          Cookies.set('token', token)
        },
        SET_USER_INFO(state, info) {
          state.userInfo = info
        },
        SET_LANG(state, lang) {
          state.lang = lang
          localStorage.setItem('admin_lang', lang)
        },
        SET_MENUS(state, menus) {
          state.menus = menus
        }
      },
      actions: {
        login({ commit }, { token, ...userInfo }) {
          commit('SET_TOKEN', token)
          commit('SET_USER_INFO', userInfo)
        },
        logout({ commit }) {
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', null)
          commit('SET_MENUS', [])
          Cookies.remove('token')
        },
        setLang({ commit }, lang) {
          commit('SET_LANG', lang)
        },
        async fetchMenus({ commit }) {
          try {
            const res = await getUserMenus()
            const menus = res.data || res || []
            commit('SET_MENUS', menus)
            return menus
          } catch (e) {
            return []
          }
        },
        async fetchUserInfo({ commit }) {
          try {
            const res = await getUserInfo()
            const info = res.data || res
            commit('SET_USER_INFO', info)
            return info
          } catch (e) {
            return null
          }
        }
      }
    }
  }
})
